import { useEffect, useState } from "react";

/** A code the phone's camera opens: this ad on the phone, ready to record the script upright. */
export function PhoneQr({ url }: { url: string }) {
  const [code, setCode] = useState<{ d: string; n: number } | null>(null);
  useEffect(() => {
    let live = true;
    // Why: loaded only when asked for, so the Ads step does not carry the code maker.
    void import("qrcode").then(({ create }) => {
      const qr = create(url, { errorCorrectionLevel: "M" });
      const n = qr.modules.size;
      let d = "";
      for (let y = 0; y < n; y++) for (let x = 0; x < n; x++) if (qr.modules.get(y, x)) d += `M${x} ${y}h1v1h-1z`;
      if (live) setCode({ d, n });
    });
    return () => {
      live = false;
    };
  }, [url]);
  return (
    <div className="pqr">
      <div className="pqr-code">
        {code ? (
          <svg viewBox={`-2 -2 ${code.n + 4} ${code.n + 4}`} role="img" aria-label="Code to open this ad on your phone">
            <path d={code.d} />
          </svg>
        ) : (
          <span className="spin" />
        )}
      </div>
      <p>Scan it with your phone's camera to record this script upright.</p>
    </div>
  );
}
